import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";

import TireRequestCard from "./../list/TireRequestCard";
import TireListingView from "./../list/TireListingView";
import {
  getMotoTiresQueryKey,
  shouldLoadMotoTiresForRoute,
} from "../../redux/utils/motoTiresQueryKey";

const styles = (theme) => ({
  header: {
    marginBottom: theme.spacing(3),
  },
  title: {
    marginTop: theme.spacing(0.5),
  },
  sizeRow: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: theme.spacing(1),
    marginTop: theme.spacing(1.5),
  },
});

class TireResultsPage extends React.Component {
  state = {};

  componentDidMount() {
    const { width, profile, rim } = this.props.match.params;
    const size = `${width}_${profile}_${rim}`;
    this.setState({ width, profile, rim, size });

    if (shouldLoadMotoTiresForRoute(this.props.catalog, width, profile, rim)) {
      this.props.actions.setListPending(true);
      this.props.actions.searchTiresByDimensions(width, profile, rim);
    }

    window.scrollTo(0, 0);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const currentSize = `${prevState.width}_${prevState.profile}_${prevState.rim}`;
    const nP = nextProps.match.params;
    const nextSize = `${nP.width}_${nP.profile}_${nP.rim}`;

    if (currentSize !== nextSize) {
      const { width, profile, rim } = nP;
      return { width, profile, rim, size: nextSize };
    }
    return null;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.size !== this.state.size) {
      const { width, profile, rim } = this.state;
      this.props.actions.setListPending(true);
      this.props.actions.searchTiresByDimensions(width, profile, rim);
      window.scrollTo(0, 0);
    }
  }

  submitTireRequest = (requestData) => {
    return this.props.actions.submitTireRequest(requestData);
  };

  renderHeader() {
    const { classes } = this.props;
    const { width, profile, rim } = this.props.match.params;

    return (
      <header className={classes.header}>
        <Typography variant="overline" color="textSecondary">
          צמיגים לאופנוע · חיפוש לפי מידה
        </Typography>
        <Typography variant="h4" component="h1" className={classes.title}>
          {"צמיגים לאופנוע במידה "}
          <bdi dir="ltr">{`${width}/${profile}-${rim}`}</bdi>
        </Typography>
        <div className={classes.sizeRow}>
          <Button component={Link} to="/" color="primary" size="small">
            שנה מידה
          </Button>
        </div>
      </header>
    );
  }

  render() {
    const { catalog, actions } = this.props;
    const { width, profile, rim } = this.props.match.params;
    const seoTireSize = `${width}/${profile}-${rim}`;
    const metaTitle = `צמיגים לאופנועים במידה ${seoTireSize} - ספורטישופ`;
    const metaDesc =
      "מגוון רחב של צמיגים במידה " +
      seoTireSize +
      " תוכלו למצוא אצלנו במגוון מותגים מובילים - עד 70% הנחה - פירלי, מישלין, מצלר, קונטיננטל, ברידגסטון ועוד";

    return (
      <React.Fragment>
        <Helmet>
          <meta property="og:title" content={metaTitle} />
          <meta property="og:description" content={metaDesc} />
          <meta property="description" content={metaDesc} />
          <title>{metaTitle}</title>
        </Helmet>
        <TireListingView
          header={this.renderHeader()}
          products={catalog.motoTires}
          pending={
            catalog.listPending ||
            catalog.motoTiresQueryKey !== getMotoTiresQueryKey(width, profile, rim)
          }
          emptyState={(
            <TireRequestCard
              tireSize={seoTireSize}
              onSubmit={this.submitTireRequest}
            />
          )}
          availabilityContext={{
            currentShipment: catalog.currentShipment,
            nextShipment: catalog.nextShipment,
            euContainerMode: catalog.euContainerMode,
          }}
          limitedTimeOffers={catalog.limitedTimeOffers || []}
          addProductsToCart={actions.addProductsToCart}
          collectMetric={actions.collectMetric}
          metricSource="list_page"
          defaultType="single"
          resetKey={`${width}_${profile}_${rim}`}
        />
      </React.Fragment>
    );
  }
}

TireResultsPage.propTypes = {
  classes: PropTypes.object.isRequired,
  actions: PropTypes.object,
  catalog: PropTypes.object.isRequired,
  match: PropTypes.object,
};

export default withStyles(styles)(TireResultsPage);
